var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "authentication" } }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        !_vm.authenticateQuestionAccepted
          ? _c("div", { staticClass: "col-md-8" }, [
              _c(
                "label",
                { staticClass: "checkbox-inline" },
                [
                  _c(
                    "validated-form-group",
                    {
                      attrs: {
                        "validation-id": "authenticationAccepted",
                        "validation-errors": _vm.validationErrors
                      }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "new-contract-value",
                            rawName: "v-new-contract-value"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "authenticationAccepted",
                          "true-value": "1",
                          "false-value": "0"
                        },
                        domProps: { value: _vm.contract.AuthenticationAccepted }
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "Tunnistautumalla hyväksyn, että sopimuksen maksutavaksi tulee lasku."
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.authenticateQuestionAccepted
          ? [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.authenticate()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("Tunnistaudu pankkitunnuksillasi")) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.testMode
                ? _c("div", [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12 ml-3" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("b-form-group", { staticClass: "mb-0" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "font-weight-bold pt-0",
                                  attrs: { for: "test-pin" }
                                },
                                [_vm._v(_vm._s(_vm.$t("Testihenkilötunnus")))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "new-contract-value",
                                  rawName: "v-new-contract-value"
                                }
                              ],
                              attrs: {
                                id: "test-pin",
                                type: "text",
                                name: "Pin",
                                value: _vm.customer.Pin
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }